import { render, staticRenderFns } from "./RelationProductDialog.vue?vue&type=template&id=41e0db5c&scoped=true&"
import script from "./RelationProductDialog.vue?vue&type=script&lang=js&"
export * from "./RelationProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelationProductDialog.vue?vue&type=style&index=0&id=41e0db5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e0db5c",
  null
  
)

export default component.exports